//Read More/Read Less - functionality
document.getElementById('read-more-toggle').addEventListener('click', function() {
    let readMoreText = document.getElementById('read-more');

    if (readMoreText.classList.contains('read-more__text--expanded')) {
      readMoreText.classList.remove('read-more__text--expanded');
      this.textContent = 'Read more';
    } else {
      readMoreText.classList.add('read-more__text--expanded');
      this.textContent = 'Read less';
    }
});

// Hide 'Read more' button if text fits within 4 lines
document.addEventListener('DOMContentLoaded', function() {
    let readMoreText = document.getElementById('read-more');
    let readMoreToggle = document.getElementById('read-more-toggle');
    let lineHeight = parseInt(window.getComputedStyle(readMoreText).lineHeight);
    let maxHeight = lineHeight * 4; // 4 lines
    
    if (readMoreText.scrollHeight <= maxHeight) {
      readMoreToggle.style.display = 'none';
    }
});